import { useCallback, useEffect, useState } from 'react'

import RafflePngs from 'assets/png'
import { ActionIconEnum } from 'common/enums/ActionIcon'
import { ScratchCard } from 'components'
import BaseBridge from 'config/bridge/BaseBridge'
import { useNavBar } from 'hooks/useNavBar'
import { useHistory } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import useBoundState from 'store'

import { Button } from '@interco/inter-ui/components/Button'
import { Carousel } from '@interco/inter-ui/components/Carousel'
import { Text } from '@interco/inter-ui/components/Text'

import * as S from './TicketsCarousel.styles'
import {
  analyticsTicketsCarousel,
  analyticsTicketsCarouselHeader,
  analyticsTicketsCarouselOpen,
  analyticsTicketCarouselUse,
} from './TicketsCarousel.tags'

export const TicketsCarousel = () => {
  const history = useHistory()
  const contentCapitalization = useBoundState((state) => state.contentCapitalization)

  const tickets = useBoundState((state) => state.tickets)
  const availableTickets = useBoundState((state) => state.availableTickets)

  const [currentSlide, setCurrentSlide] = useState(0)
  const [tempCurrentSlide, setTempCurrentSlide] = useState(-1)

  const HAS_TICKETS_AFTER_SALES = Object.keys(tickets).length !== 0

  const goToAfterSales = useCallback(() => {
    setTimeout(() => history.push(TypesRoutes.AFTER_SALES), 50)
  }, [history])

  const handleBack = useCallback(() => {
    HAS_TICKETS_AFTER_SALES ? goToAfterSales() : BaseBridge.requestGoBack()
  }, [HAS_TICKETS_AFTER_SALES, goToAfterSales])

  useNavBar({
    actionIcons: {
      leftIcon: ActionIconEnum.BACK,
      rightIcon: ActionIconEnum.FAQ,
    },
    backListener: handleBack,
    backButtonCallback: () => analyticsTicketsCarouselHeader('10', 'back'),
    helpButtonCallback: () => analyticsTicketsCarouselHeader('12', 'ajuda'),
  })

  useEffect(() => {
    BaseBridge.tacWb({
      name: 'carousel_screen_loaded',
      module: 'capitalizacao',
      actions: ['go_back', 'enter_tickets_carousel'],
      params: {},
    })
  }, [])

  useEffect(() => {
    if (availableTickets.length > 0) {
      analyticsTicketsCarouselOpen(`${availableTickets.length}`)
    }
  }, [availableTickets])

  const renderScratchcards = () => {
    if (availableTickets[currentSlide] && currentSlide !== tempCurrentSlide) {
      const actionId = `${contentCapitalization.value1} ${availableTickets[currentSlide].luckyNumber}`
      analyticsTicketsCarousel(actionId)
      setTempCurrentSlide(currentSlide)
    }

    return availableTickets.map((card, index) => (
      <S.SliderContent key={card.ticketId}>
        <ScratchCard scale={index !== currentSlide ? 400 : 500} onClick={handleClickTicket}>
          {RafflePngs.carouselGift}
          <Text variant="body-3" bold>
            {contentCapitalization.value1}
          </Text>
          <Text variant="body-1" as="h3" bold>
            {card.luckyNumber}
          </Text>
        </ScratchCard>
      </S.SliderContent>
    ))
  }

  const handleClickTicket = () => {
    BaseBridge.ticWb({
      name: 'load_game_btn',
      module: 'capitalizacao',
      action: 'use_ticket',
      params: {},
    })
    useBoundState.setState({
      isAllScratch: false,
      currentTicket: availableTickets[currentSlide],
    })
    analyticsTicketCarouselUse(`Capitalização ${availableTickets[currentSlide].luckyNumber}`)
    history.push(TypesRoutes.GAME)
  }

  const renderStickFooter = (
    <S.Footer>
      <Button
        data-testid="btn-use-ticket"
        variant="secondary"
        fullWidth
        onClick={handleClickTicket}
      >
        Usar {contentCapitalization.value1}
      </Button>
    </S.Footer>
  )

  return (
    <S.Container>
      <Text variant="headline-h1" as="h1" semiBold>
        Escolha qual quer raspar
      </Text>

      <Text variant="body-3">{`${availableTickets.length} disponíveis`}</Text>

      <S.Slider>
        <Carousel
          dots
          arrows={false}
          infinite={false}
          speed={1000}
          slidesToShow={1}
          dotsType="medium"
          verticalMode={false}
          centerMode
          centerPadding="120px"
          className="slider"
          beforeChange={(_oldIndex, newIndex) => {
            setCurrentSlide(newIndex)
          }}
        >
          {renderScratchcards()}
        </Carousel>
      </S.Slider>

      {renderStickFooter}
    </S.Container>
  )
}
